import script from "./SearchPageSearchResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageSearchResult.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__